export class UnauthorizedError extends Error {
  constructor(message, data) {
    super(message, data);
    if (!message) {
      this.message = "Unauthorized Error";
    }
    this.data = data;
    this.status_code = 401;
  }
}
